// extracted by mini-css-extract-plugin
module.exports = {"form":"UserTeamForm_form__1YznV","saveButton":"UserTeamForm_saveButton__31zlX"};